const channels = {
  JOIN_GAME: 'join-game',
  UPDATE_DIRECTION: 'update-direction',
  GAME_END: 'game-end',
  DISCONNECT: 'disconnect',
  CONNECTED: 'connected',
  ROOM_CREATED: 'room-created',
  GAME_UPDATE: 'game-update',
  ROOM_FULL: 'room-full',
  GAME_OVER: 'game-over',
  PING: 'pinging',
  SYNC: 'sync',
};

export default channels;
